export const customColors = {
  lightBlue: '#8BBCCC',
  blue: '#4C6793',
  purple: '#5C2E7E',
  buttonBlue: '#0165F2',
}
